/**
 * Pathnames that host guest-only auth UI (RequireGuestAuth).
 * Used by shell chrome to avoid signed-in affordances over guest forms.
 */

const GUEST_AUTH_LEAF_SEGMENTS = [
  '/sign-in',
  '/sign-up',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/confirm-email',
] as const;

export function isGuestAuthPath(pathname: string): boolean {
  const normalized =
    pathname.endsWith('/') && pathname.length > 1
      ? pathname.slice(0, -1)
      : pathname;

  // Real route is `sign-up/pending` (not a hyphenated leaf).
  if (
    normalized === '/sign-up/pending' ||
    normalized.endsWith('/sign-up/pending')
  ) {
    return true;
  }

  return GUEST_AUTH_LEAF_SEGMENTS.some((segment) => {
    if (normalized === segment) {
      return true;
    }
    const idx = normalized.lastIndexOf(segment);
    if (idx < 0) {
      return false;
    }
    // Match `/{tenant}/sign-in` — not `/…/sign-in-extra`.
    const after = normalized.slice(idx + segment.length);
    return after.length === 0;
  });
}
